import React from 'react';

type ConditionalWrapProps = {
  condition: boolean;
  children: React.ReactElement;
  wrap: (wrapper: React.ReactElement<any, any>) => React.ReactElement<any, any>;
};

export const ConditionalWrap: React.FC<ConditionalWrapProps> = ({
  condition,
  children,
  wrap,
}) => (condition ? React.cloneElement(wrap(children)) : children);

export default ConditionalWrap;
